<template>
	<el-row>
		<div style="display: flex;justify-content: space-between;align-items: center;margin-bottom: 20px;">
			<div style="width: 300px;">
				订单：{{info.orderNo}}
				<span style="padding-left: 10px;" v-if="info.status == 0">待付款</span>
				<span style="padding-left: 10px;" v-if="info.status == 1">已支付</span>
				<span style="padding-left: 10px;" v-if="info.status == 2">已完成</span>
				<span style="padding-left: 10px;" v-if="info.status == 3">已取消</span>
				<span style="padding-left: 10px;" v-if="info.status == 4">交易关闭</span>
			</div>
			<div style="width: 300px;">
				下单用户:{{info.memberName}}
				<el-tooltip class="item" placement="top">
					<div slot="content">
						<p>用户昵称：{{info.memberName}}</p>
						<p> 用户id：{{info.memberId}}</p>
						<!-- <p>上级昵称：李大虎</p> -->
						<p>上级id：{{info.agentId}}</p>
						<p>上级工号：{{info.refereeCode}}</p>
					</div>
					<el-button type="text" style="margin-left: 10px;">查看</el-button>
				</el-tooltip>
			</div>
			<div style="width: 300px;">下单时间: {{info.created}}</div>
			<div style="width: 300px;">支付时间: {{info.paymentTime}}</div>
		</div>
		<li>商品信息</li>
		<el-table :data="tableDate" :header-cell-style="{background: '#f2f2f2',color: '#666666'}">
			<el-table-column label="商品" width="300px" prop="coursePic">
				<template slot-scope="scope">
					<div style="display: flex;align-items: center;">
						<div>
							<el-image style="width: 150px; height: 100px;" :src="scope.row.coursePic" />
						</div>
						<div>
							{{scope.row.courseName}}</br>
							{{scope.row.courseSubTitle}}
						</div>
					</div>
				</template>
			</el-table-column>
			<el-table-column label="课件id" prop="courseId"></el-table-column>
			<el-table-column label="方向" prop="courseDirectionName"></el-table-column>
			<el-table-column label="分类" prop="courseCategoryName"></el-table-column>
			<el-table-column label="售价" prop="coursePrice">
				<template slot-scope="scope">
					￥{{scope.row.coursePrice}}元
				</template>
			</el-table-column>
			<el-table-column label="购买数量" prop="courseQuantity"></el-table-column>
			<!-- <el-table-column label="赠送积分" prop=""></el-table-column> -->
		</el-table>
		<div style="width: 95%;height: 50px;text-align: end;line-height: 50px">
			商品总计：<strong style="color: #ff0000;">￥{{total}}元</strong>
		</div>

		<li>赠品信息</li>
		<el-table :data="tableDate2" :header-cell-style="{background: '#f2f2f2',color: '#666666'}">
			<template slot="empty">
				~~~ 无赠品 ~~~
			</template>
			<el-table-column label="商品" width="300px">
			</el-table-column>
			<el-table-column label="描述" prop="sl"></el-table-column>
			<el-table-column label="赠送数量" prop="jf"></el-table-column>
		</el-table>

		<li>优惠信息</li>
		<el-table :data="tableDate3" :header-cell-style="{background: '#f2f2f2',color: '#666666'}">
			<el-table-column label="优惠类型" prop="title"></el-table-column>
			<el-table-column label="描述" prop="con"></el-table-column>
			<el-table-column label="优惠金额">
				<template slot-scope="scope">
					￥{{scope.row.pic}}元
				</template>
			</el-table-column>
		</el-table>
		</div>
		<ul style="margin-left: 80%;">
			<li>商品总计：<strong style="color: #ff0000;">￥{{info.totalAmount}}元</strong></li>
			<li>优惠总计：<strong style="color: #ff0000;">￥{{info.redpacketAmount}}元</strong></li>
			<li>应付金额：<strong style="color: #ff0000;">￥{{info.payAmount}}元</strong></li>
			<li>实付金额：<strong style="color: #ff0000;">￥{{info.payAmount}}元</strong></li>
			<li>支付方式:<strong>微信支付</strong></li>
		</ul>

		<li>操作信息</li>
		<el-table :data="tableDate4" border :header-cell-style="{background: '#f2f2f2',color: '#666666'}">
			<el-table-column label="操作者" prop="type">
				<template slot-scope="scope">
					{{scope.row.type == 0 ? '用户' : '系统'}}
				</template>
			</el-table-column>
			<el-table-column label="操作时间" prop="operationTime"></el-table-column>
			<el-table-column label="订单状态" prop="status">
				<template slot-scope="scope">
					{{scope.row.status == 0 ? '待付款' : '支付'}}
				</template>
			</el-table-column>
			<el-table-column label="付款状态" prop="payStatus">
				<template slot-scope="scope">
					{{scope.row.payStatus == 0 ? '未支付' : '支付'}}
				</template>
			</el-table-column>
			<el-table-column label="发货状态" prop="goodsStatus">
				<template slot-scope="scope">
					{{scope.row.goodsStatus == 0 ? '未发货' : '已发货'}}
				</template>
			</el-table-column>
			<el-table-column label="备注" prop="remark"></el-table-column>
		</el-table>
	</el-row>
</template>

<script>
	export default {
		data() {
			return {
				tableDate: [],
				tableDate2: [],
				tableDate3: [],
				tableDate4: [],
				info: {
					orderNo: '',
					status: '',
					memberName: "",
					created: '',
					paymentTime: '',
					memberId: "",
					totalAmount: '',
					payAmount: '',
					redpacketAmount: '',
					integralAmount: '',
					activityAmount: '',
					wxName: "",
					refereeCode: null,
					agentId: "",
				},
				total: '',
			}
		},
		methods: {
			getInfo() {
				this.$http.get("/api/clrorder/ClrOrdersController/clrOrderDetail?orderId=" + this.$route.query.orderId, {})
					.then(res => {
						let courseOrderInfo = res.data.data.courseOrderInfo
						this.info.memberId = courseOrderInfo.memberId
						this.$http.get(`/api/user/umsMember/selectMemberInfoById?memberId=${this.info.memberId}`, {})
							.then(res => {
								console.log(res);
								this.info.agentId = res.data.data.refereeId
								this.info.refereeCode = res.data.data.refereeCode
							})
						//优惠类型
						this.tableDate3.push({
							title: '优惠券',
							con: '无',
							pic: courseOrderInfo.redpacketAmount
						}, {
							title: '促销活动',
							con: '无',
							pic: courseOrderInfo.activityAmount
						}, {
							title: '积分抵扣',
							con: '无',
							pic: courseOrderInfo.integralAmount
						},
						{
							title: '其他抵扣',
							con: '无',
							pic: 0
						})
						this.info.orderNo = courseOrderInfo.orderNo
						this.info.status = courseOrderInfo.status
						this.info.memberName = courseOrderInfo.memberName
						this.info.created = courseOrderInfo.created
						this.info.paymentTime = courseOrderInfo.paymentTime
						this.info.totalAmount = courseOrderInfo.totalAmount
						this.info.payAmount = courseOrderInfo.payAmount
						this.info.redpacketAmount = courseOrderInfo.redpacketAmount
						this.info.integralAmount = courseOrderInfo.integralAmount
						this.info.activityAmount = courseOrderInfo.activityAmount
						console.log(res.data.data);
						//商品信息
						let orderDetailInfo = res.data.data.orderDetailInfo
						this.total = orderDetailInfo[0].totalPrice
						this.tableDate = orderDetailInfo
						//操作信息
						let operationInfo = res.data.data.operationInfo
						this.tableDate4 = operationInfo
						// console.log(operationInfo);
					})
			}
		},
		created() {
			this.getInfo()
		}
	}
</script>

<style scoped="scoped">
	li {
		margin: 10px 0px;
	}

	ul li {
		list-style: none;
	}
</style>
